import type { PropsWithChildren } from 'react'
import { View, type ViewProps, type ViewStyle } from 'react-native'
import { useCreateStyles } from './styles'

interface Props extends ViewProps {
  width?: ViewStyle['width']
  height?: ViewStyle['height']
  radius?: number
}

export function SkeletonBlock({ width, height, radius, style, children, ...props }: PropsWithChildren<Props>) {
  const styles = useCreateStyles()

  return (
    <View
      {...props}
      style={[
        styles.block,
        {
          width,
          height,
          borderRadius: radius,
        },
        style,
      ]}
    >
      {children ? <View style={{ opacity: 0 }}>{children}</View> : null}
    </View>
  )
}
